import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";

let token = sessionStorage.getItem("token");

//get Custmor Name wise Report
export const getCustomerWise = (pageNo, customerName) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `getCustomerNameWiseCustomerReport/${pageNo}?customerName=${customerName}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

//get Dealer Name wise Report
export const getDealerWise = (pageNo, dealerName) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `getDealerDetailsByDealerName/${pageNo}?dealerName=${dealerName}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

// export const getDealerByCustomerName = (pageNo, dealerName) => {
//   let token = sessionStorage.getItem("token");
//   let role = sessionStorage.getItem("role");
//   let fkUserId = sessionStorage.getItem("pkUserId");
//   return Axios.get(
//     `getDealerDetailsByCustomerName/${pageNo}?role=${role}&customerName=${dealerName}&fkUserId=${fkUserId}`,
//     {
//       headers: { Authorization: `Bearer ${token}` },
//     }
//   );
// };

//get Service Engineer Name wise Report
export const getServiceEngWise = (pageNo, serviceEngineerName) => {
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  let token = sessionStorage.getItem("token");
  return Axios.get(
    // `petrotec/getServiceEngineerNameWiseReportForUser/${pageNo}?serviceEngineerName=${serviceEngineerName}&fkUserId=${fkUserId}&role=${role}`,
    `/getServiceEngineerNameWiseReportForUser/${pageNo}?serviceEngineerName=${serviceEngineerName}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

//get Customer Name wise dispatch Report
export const getCustomerWiseDispatch = (pageNo, customerName) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `getCustomerNameWiseDispatchReport/${pageNo}?customerName=${customerName}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

//get Dealer Name wise dispatch Report
export const getDealerWiseDispatch = (pageNo, dealerName) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `getDealerNameWiseDispatchReport/${pageNo}?dealerName=${dealerName}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

//get Customer Name wise Work Order Report
export const getCustomerWiseInstalltionReport = (
  pageNo,
  customerName,
  jobType
) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `customerNameWiseWorkOrderReport/${pageNo}?customerName=${customerName}&jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

//get Dealer Name wise Installation Report
export const getDealerWiseInstallationReport = (
  pageNo,
  dealerName,
  jobType
) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  // let jobType = ["installation"];
  return Axios.get(
    `dealerNameWiseWorkOrderReport/${pageNo}?dealerName=${dealerName}&jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

//get Service Engineer Name wise Work Order
export const getServiceEngWiseInstallationReport = (
  pageNo,
  serviceEngineerName,
  jobType
) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `serviceEngineerWiseWorkOrderReport/${pageNo}?serviceEngineerName=${serviceEngineerName}&jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const getWorkOrderNoReport = (workOrderNo, jobType) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `workOrderNoWiseReport?workOrderNo=${workOrderNo}&jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};
//get Field Issue History
export const getFieldHistory = (pageNo, fkUserId, role, headers) => {
  return Axios.get(
    `getFieldIssueHistoryDetails/${pageNo}?fkUserId=${fkUserId}&role=${role}`,
    {
      headers,
    }
  );
};

//get Calibration History
export const getCalibrationHistory = (pageNo, pkFieldIssueHistoryId, role, headers) => {
  return Axios.get(
    `getCalibrationHistoryDetails/${pageNo}?fkUserId=${pkFieldIssueHistoryId}&role=${role}`,
    {
      headers,
    }
  );
};

export const getCustomerDDFWorkOrderR = (headers, jobType) => {
  return Axios.get(`getCustomerDropDownForWorkOrderReport?jobType=${jobType}`, {
    headers,
  });
};

export const getDealerDDFWorkOrderR = (headers, jobType) => {
  return Axios.get(`getDealerDropDownForWorkOrderReport?jobType=${jobType}`, {
    headers,
  });
};

export const getServiceEngDDFWorkOrderR = (headers, jobType) => {
  return Axios.get(
    `getServiceEngineerDropDownForWorkOrderReport?jobType=${jobType}`,
    {
      headers,
    }
  );
};

export const getCustomerDDFDealerList = () => {
  return Axios.get("getCustomerDropDownForDealer", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getCustomerDDFDispatchR = (headers) => {
  return Axios.get("getCustomerDropDownForDispatchReport", {
    headers,
  });
};

export const getDealerDDFDispatchR = (headers) => {
  return Axios.get("getDealerDropDownForDispatchReport", {
    headers,
  });
};

export const getDispenserRecord = (headers, dispenserSrNo) => {
  return Axios.get(
    `getDispenserSrNoWiseBoradNoReport?dispenserSrNo=${dispenserSrNo}`,
    {
      headers,
    }
  );
};

export const getDispenserNoNotAllocatedList = (pageNo, headers, status) => {
  return Axios.get(
    `getDispenserNoNotAllocatedList/${pageNo}?status=${status}`,
    {
      headers,
    }
  );
};
